import { render, staticRenderFns } from "./ScrollSpyBox.vue?vue&type=template&id=8eb5d800&scoped=true&"
import script from "./ScrollSpyBox.vue?vue&type=script&lang=js&"
export * from "./ScrollSpyBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb5d800",
  null
  
)

export default component.exports